import { useState } from "react";
import Header from "../Header";
import axios from 'axios';

const Leadwait = () => {
    // const role = localStorage.getItem('role');
    // const id = localStorage.getItem('userId');
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [alertType, setAlertType] = useState(''); 
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
     const [watiChecked, setWatiChecked] = useState(false);

     const handleSubmit = async () => {       

            const dataToSend = {
                templateName: selectedTemplate,
                broadcastName: selectedTemplate,
                status: selectedStatus,
            };

            console.log('Sending data to API:', dataToSend);

            try {
                setLoading(true);
                const response = await axios.post(
                 `https://apiaksharaconnect.aksharafinalytics.in/BulkWati`,
                dataToSend
                );

                console.log('Response from API:', response.data);

                setAlertType('success');
                setMessage(response.data.message || 'Template sent and saved.');
            } catch (error) {
                console.error('API Error:', error.response?.data || error.message);
                setAlertType('danger');
                setMessage(error.response?.data?.message || 'Failed to send/insert.');
            } finally {
                setLoading(false);
            }
        };


    return (
        <>
            <Header />
            <div className="container mt-5">
            {message && (
                <div className={`mt-3 alert alert-${alertType}`} role="alert">
                    {message}
                </div>
            )}

                <div className="card shadow">                    
                    <div className="card-header">
                        <h2>Leads -  Bulk Wati  </h2>
                    </div>
                    
                    <div className="card-body">
                            <div className="mb-3">
                                <label className="form-label">Template</label>
                               <select className="form-select" id="templateSelect" value={selectedTemplate} onChange={(e) => setSelectedTemplate(e.target.value)}>
                                    <option value="">-- Select Template --</option>
                                    <option value="initial_contact">Initial Contact</option>
                                    <option value="inquiry_response">Initial Response</option>
                                    <option value="offers">Offers</option>
                                    <option value="request_appointment">Request Appointment</option>
                                    <option value="followup_msg">followup msg</option>
                                    <option value="quotation_request">Quotation Request</option>
                                </select>
                            </div>
                             <div className="mb-3">
                                <label className="form-label">Status</label>
                               <select className="form-select" id="templateSelect" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                                    <option value="">-- Select Option --</option>
                                    <option value="open">Open</option>
                                    <option value="in-progress">In Progress</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            
                            <center>
                                 <button className="btn btn-primary" onClick={handleSubmit} disabled={loading} >
                                 {loading ? 'Sending...' : 'Submit'}
                                </button>
                               
                            </center>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Leadwait;
